import React, { lazy } from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const includesList = ['Todo el MegaPack Base', 'Todo el MegaPack Gestión Completa', '6 Planillas Profesionales', 'Láminas Visuales Educativas', 'Recetas Completas Listas', 'Planes por Patología y Necesidad'];
const mockupItems = [{
  id: 'laminas',
  emoji: '🖼️',
  label: 'Láminas Educativas',
  sub: 'Láminas Visuales',
  border: '#60a5fa',
  bg: 'linear-gradient(135deg, #bfdbfe, #93c5fd)',
  textColor: 'text-blue-700',
  imageUrl: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1781020673/hf_20260609_155227_ce9399f4-1cca-4b07-adcd-be904ca8d64c_1_kt5une.webp'
}, {
  id: 'recetas',
  emoji: '🥗',
  label: 'Recetas Completas',
  sub: 'Recetas Listas',
  border: '#34d399',
  bg: 'linear-gradient(135deg, #d1fae5, #6ee7b7)',
  textColor: 'text-emerald-700',
  imageUrl: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1781021461/hf_20260609_161011_a7b6e45e-a15f-4b09-bd7d-b6081ca4d61d_tfvcun.webp'
}, {
  id: 'planes-patologia',
  emoji: '📋',
  label: 'Planes por Patología',
  sub: 'Planes Adaptados',
  border: '#f472b6',
  bg: 'linear-gradient(135deg, #fce7f3, #fbcfe8)',
  textColor: 'text-pink-700',
  imageUrl: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1781020649/hf_20260609_155625_ddaf8581-665b-46bf-85e9-aeef65597650_gzqvbb.webp'
}, {
  id: 'planes-necesidad',
  emoji: '🎯',
  label: 'Planes por Necesidad',
  sub: 'Por Perfil de Paciente',
  border: '#fbbf24',
  bg: 'linear-gradient(135deg, #fef3c7, #fde68a)',
  textColor: 'text-amber-700',
  imageUrl: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1781021608/hf_20260609_161239_162588b5-bf20-4e1a-aef3-44f0b080d801_ubyzar.webp'
}];
export function ProBusiness() {
  useTrackSection('pro-business', 'Pro Business Section');
  return <section id="pro-business" className="w-full px-4 sm:px-6 lg:px-8 py-12 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(248,250,252) 60%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-238">
      <div className="mx-auto max-w-3xl" data-id="element-239">
        {/* Badge */}
        <div className="flex justify-center mb-4" data-id="element-240">
          <span className="text-sm sm:text-base font-black text-white px-6 py-2.5 rounded-full" style={{
          background: 'linear-gradient(135deg, #f59e0b, #d97706)'
        }} data-id="element-241">
            🏆 OFERTA 3 — LA MÁS COMPLETA
          </span>
        </div>

        {/* Header */}
        <h2 className="text-3xl sm:text-4xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-242">
          MegaPack{' '}
          <span style={{
          background: 'linear-gradient(135deg, #f59e0b, #d97706)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }} data-id="element-243">
            Consultorio Profesional
          </span>
        </h2>
        <p className="text-center text-sm text-gray-500 mx-auto max-w-xl m-0 mb-10" data-id="element-244">
          Todo lo que necesitás para que tu consultorio funcione, se vea
          profesional y resuelva cada consulta sin improvisar.
        </p>

        {/* Mockup Area */}
        <div className="rounded-2xl overflow-hidden mb-10 shadow-lg" style={{
        background: 'linear-gradient(135deg, #fef3c7 0%, #d1fae5 100%)',
        border: '2px solid #fcd34d'
      }} data-id="element-245">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 p-6 pb-4" data-id="element-246">
            {mockupItems.map(item => <div key={item.id} className="flex flex-col items-center gap-2" data-id="element-247">
                <div className="w-full rounded-xl overflow-hidden shadow-md" style={{
              height: '140px',
              background: item.imageUrl ? 'transparent' : item.bg,
              border: `2px dashed ${item.border}`
            }} data-id="element-248">
                  {item.imageUrl ? <img src={item.imageUrl} alt={item.label} width={200} height={140} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-249" /> : <div className="w-full h-full flex flex-col items-center justify-center gap-1 px-2" data-id="element-250">
                      <div className="text-3xl" data-id="element-251">{item.emoji}</div>
                      <div className={`text-[11px] font-black text-center leading-tight ${item.textColor}`} data-id="element-252">
                        {item.label}
                      </div>
                    </div>}
                </div>
                <span className="text-[10px] text-gray-500 font-semibold text-center leading-tight" data-id="element-253">
                  {item.sub}
                </span>
              </div>)}
          </div>

          {/* Label inferior */}
          <div className="mx-4 mb-4 rounded-xl px-4 py-2 flex items-center justify-center" style={{
          background: 'rgba(255,255,255,0.8)'
        }} data-id="element-254">
            <span className="text-[11px] font-black uppercase tracking-wide text-center" style={{
            color: '#d97706'
          }} data-id="element-255">
              🌿 Material Visual Completo — exclusivo Oferta 3
            </span>
          </div>
        </div>

        {/* Qué incluye */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-sm" style={{
        border: '1px solid #fcd34d'
      }} data-id="element-256">
          <div className="px-5 py-3" style={{
          background: 'linear-gradient(135deg, #fef3c7, #fde68a)'
        }} data-id="element-257">
            <h3 className="text-sm font-black m-0 tracking-wide uppercase" style={{
            color: '#92400e'
          }} data-id="element-258">
              ✅ Todo lo que incluye:
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-259">
            {includesList.map(item => <div key={item} className="flex items-center gap-3 px-5 py-3" data-id="element-260">
                <span className="shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-black text-white" style={{
              background: 'linear-gradient(135deg, #f59e0b, #d97706)'
            }} data-id="element-261">
                  ✓
                </span>
                <span className="text-sm font-bold text-gray-900" data-id="element-262">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}